<template>
  <CustomPage :noTitle="true">
    <div slot="content" class="content">
      <div class="brand-place relative h-full flex flex-col">
        <div
          class="pb-20"
          :style="
            brandDetail.enterImg
              ? {
                  background: 'no-repeat center top / 100%',
                  backgroundImage: `linear-gradient(rgba(255, 255, 255, 0),rgba(255, 255, 255, 1)),url(${brandDetail.enterImg})`,
                  height: `${fold ? 100 : 300}px`,
                  transition: `0.3s`,
                }
              : {
                  background: 'linear-gradient(black, white)',
                  height: `${fold ? 100 : 300}px`,
                  transition: `0.3s`,
                }
          "
        >
          <div id="shadow" :style="{ height: `${fold ? 100 : 300}px` }"></div>
          <NavBar
            class="py-1"
            left-arrow
            @click-left="back"
            style="background-color: transparent"
          >
            <template #left>
              <Icon name="arrow-left" color="white" size="24" />

              <div
                v-if="fold"
                class="flex flex-row items-center"
                style="margin-left: 17px;"
              >
                <div style="height: 28px; width: 28px">
                  <img :src="brandDetail.brandLogo" class="h-full w-full" />
                </div>

                <div class="p-3 text-white" style="padding-left: 10px;">
                  <div
                    class="text-base"
                    style="font-size: 20px; line-height: 22px;"
                  >
                    {{ brandDetail.brandName }}
                  </div>
                  <div
                    style="font-size: 8px; line-height: 10px;"
                    class="font-xxxs text-left"
                  >
                    共{{ brandDetail.goodsNum }}款
                  </div>
                </div>
              </div>
            </template>
            <template #right>
              <div class="text-white w-32 flex justify-end pt-2">
                <div class="inline-block" @click="like">
                  <img
                    v-if="isFollowing"
                    height="24"
                    width="24"
                    src="@/assets/brandplace/like.svg"
                    alt
                  />
                  <img
                    v-else
                    height="24"
                    width="24"
                    src="@/assets/brandplace/like空心.svg"
                    alt
                  />
                  <div class="text-xxs text-center font-light">关注</div>
                </div>
                <div
                  v-if="fold && $store.state.user.distributionFlag"
                  class="inline-block ml-2"
                  @click="showDiag"
                >
                  <img
                    height="24"
                    width="24"
                    src="@/assets/brandplace/forward.svg"
                    alt
                  />
                  <div class="text-xxs text-center font-light">转发</div>
                </div>
                <div
                  v-if="fold && !$store.state.user.distributionFlag"
                  class="inline-block ml-2"
                  @click="
                    () => {
                      jiajiaway = 1
                      generatePost()
                      if (browserType !== 'weixin') showOverlay2 = true
                    }
                  "
                >
                  <img
                    height="24"
                    width="24"
                    src="@/assets/brandplace/forward.svg"
                    alt
                  />
                  <div class="text-xxs text-center font-light">转发</div>
                </div>
                <div
                  class="inline-block ml-2"
                  @click="$router.push({ name: 'HomeMessage' })"
                >
                  <div
                    v-if="messageTotal"
                    class="bg-white w-4 h-4 rounded-full absolute text-xs text-red mr-1"
                    style="right: 4px; transform: scale(0.9)"
                  >
                    <span>{{ messageTotal }}</span>
                  </div>
                  <img
                    height="24"
                    width="24"
                    src="@/assets/brandplace/message.svg"
                    alt
                  />
                  <div class="text-xxs text-center font-light">消息</div>
                </div>
              </div>
            </template>
          </NavBar>
          <div
            v-if="!fold"
            class="flex flex-row flex-no-wrap justify-between items-center p-3 relative"
            style="z-index: 1;"
          >
            <div class="flex flex-row items-center">
              <div style="height: 46px; width: 46px">
                <img :src="brandDetail.brandLogo" class="h-full w-full" />
              </div>

              <div class="p-3 text-white">
                <div class="text-base">{{ brandDetail.brandName }}</div>
                <div style class="font-xxxs text-left">
                  共{{ brandDetail.goodsNum }}款
                </div>
              </div>
            </div>
            <Button
              v-if="$store.state.user.distributionFlag"
              style="padding-left: 12px; padding-right: 12px"
              round
              :icon="require('@/assets/brandplace/forwardzhuanqian.svg')"
              color="linear-gradient(315deg, #F54365 0%, #E82035 100%)"
              size="small"
              class="text-xs"
              v-gapclick="showDiag"
              >转发赚钱</Button
            >
            <Button
              v-else
              style="padding-left: 12px; padding-right: 12px"
              round
              :icon="require('@/assets/brandplace/forwardzhuanqian.svg')"
              color="linear-gradient(315deg, #F54365 0%, #E82035 100%)"
              size="small"
              class="text-xs"
              v-gapclick="
                () => {
                  jiajiaway = 1
                  generatePost()
                  if (browserType !== 'weixin') showOverlay2 = true
                }
              "
              >转发会场</Button
            >
          </div>
          <Overlay
            :show="diagVisible"
            @click="
              () => {
                diagVisible = false
                showShare = false
              }
            "
          >
            <div
              v-show="!showShare"
              class="wrapper mx-12"
              :class="showInput ? 'my-6' : 'my-12'"
              @click.stop
            >
              <div class="bg-white rounded-lg mb-6 overflow-auto p-3 text-left">
                <div class="flex items-center mb-2">
                  <div
                    style="height: 46px; width: 46px"
                    class="flex-shrink-0 mr-3"
                  >
                    <img
                      :src="brandDetail.brandLogo"
                      class="h-full w-full rounded"
                      alt
                    />
                  </div>
                  <div class="flex justify-between flex-grow">
                    <div class="text-xs font-semibold">
                      {{ brandDetail.brandName }}
                    </div>
                    <div class="text-xs text-red font-semibold">
                      {{ brandDetail.goodsNum }}件商品
                    </div>
                  </div>
                </div>
                <div class="flex justify-center">
                  <div style="height: 182px; width: 182px" class="mr-1">
                    <img
                      :src="forwardDetail.posterImg"
                      class="h-full w-full rounded"
                      alt
                    />
                  </div>
                  <div class="flex flex-col justify-between">
                    <img
                      style="height: 89px; width: 89px"
                      :src="forwardDetail.rightImgOne"
                      alt
                      class="rounded"
                    />
                    <img
                      style="height: 89px; width: 89px"
                      :src="forwardDetail.rightImgTwo"
                      alt
                      class="rounded"
                    />
                  </div>
                </div>
                <div class="flex justify-between mb-3 pt-1">
                  <div class="text-red">
                    <span class="text-xs">
                      品牌全场 ¥
                      <span class="font-semibold mr-1 text-base">{{
                        forwardDetail.price
                      }}</span
                      >起
                    </span>
                    <div class="text-xxs font-semibold text-red">
                      赚：{{ forwardDetail.saveProfit }}元起
                    </div>
                  </div>

                  <div class="text-xs mt-1">
                    {{
                      dayjs(forwardDetail.activityTime).format(
                        'MM[月]DD[日] HH:mm'
                      )
                    }}结束
                  </div>
                </div>
                <NumberKeyboard
                  v-model="customjiajia"
                  :show="showInput"
                  theme="custom"
                  extra-key="."
                  close-button-text="完成"
                  @blur="showInput = false"
                />
              </div>
              <Button
                style="height: 2rem"
                round
                color="linear-gradient(135deg, #E82237 0%, #FF9D9D 100%)"
                size="large"
                v-gapclick="generatePost"
                >生成海报</Button
              >
            </div>
          </Overlay>
          <Overlay
            :show="showOverlay2"
            @click="
              () => {
                showOverlay2 = false
                showShare = false
              }
            "
          ></Overlay>

          <div
            v-if="!fold"
            class="flex flex-row flex-no-wrap font-xxxs text-white relative"
            style="z-index: 1;"
            @click="() => (expandDesc = !expandDesc)"
          >
            <div
              class="overflow-y-hidden pl-6 text-left flex-grow"
              style="min-height: 2rem"
              :style="{ height: expandDesc ? '' : '2rem' }"
            >
              {{ brandDetail.brandIntroduce }}
            </div>
            <div class="font-xs self-end mr-3">
              <Icon v-if="expandDesc" name="arrow-up" />
              <Icon v-else name="arrow-down" />
            </div>
          </div>

          <Tabs
            v-model="activeTab"
            :background="fold ? 'white' : 'transparent'"
            :color="!diagVisible ? 'white' : 'transparent'"
            class="text-white"
            @click="clickTabs"
          >
            <Tab>
              <template #title>
                <span :class="{ 'text-black': fold, 'text-white': !fold }"
                  >商品</span
                >
              </template>
            </Tab>
            <Tab>
              <template #title>
                <span :class="{ 'text-black': fold, 'text-white': !fold }"
                  >活动</span
                >
              </template>
            </Tab>
            <Tab>
              <template #title>
                <span :class="{ 'text-black': fold, 'text-white': !fold }"
                  >分类</span
                >
              </template>
            </Tab>
            <Tab v-if="$store.state.user.distributionFlag">
              <template #title>
                <span :class="{ 'text-black': fold, 'text-white': !fold }"
                  >发现</span
                >
              </template>
            </Tab>
          </Tabs>
        </div>
        <Notice
          :services="brandDetail.partServices"
          :deliverDay="brandDetail.deliverDay"
          :deliverAddress="brandDetail.deliverAddress"
          :couponList="brandDetail.couponList"
          @showGetCoupon="showGetCoupon"
          v-if="!fold"
        />
        <ActionSheet v-model="showCoupon" title="优惠券">
          <div class="m-3 overflow-y-auto" style="max-height: 21rem">
            <div
              v-for="item in brandDetail.couponList"
              :key="item.id"
              class="rounded-md border flex flex-row text-white mb-3 items-center justify-between pr-3"
              :style="{
                borderColor:
                  item.getstatus !== 'got' && !item.isClaim
                    ? '#E89A52'
                    : '#CECECE',
              }"
            >
              <div
                class="w-40 flex flex-col justify-center items-center p-3"
                :style="{
                  background:
                    item.getstatus !== 'got' && !item.isClaim
                      ? 'linear-gradient(90deg, #FBC787 0%, #E79950 100%)'
                      : '#CECECE',
                }"
              >
                <div>
                  <span class="text-xl">¥&nbsp;</span>
                  <span
                    class="leading-10 font-semibold"
                    style="letter-spacing: 0.1rem; font-size: 2.5rem"
                    >{{ item.faceValue }}</span
                  >
                </div>
                <div class="text-xs">
                  满{{ item.threshold ? item.threshold : '任意' }}元可用
                </div>
              </div>
              <div class="text-left flex-grow ml-3">
                <div class="text-black text-sm mb-1">{{ item.couponName }}</div>
                <div class="text-xs text-gray">
                  {{ item.startDate }} - {{ item.endDate }}
                </div>
              </div>
              <div>
                <Button
                  :disabled="item.getstatus === 'got' || item.isClaim"
                  class="w-20"
                  style="padding-left: 12px; padding-right: 12px"
                  round
                  :color="
                    item.getstatus !== 'got' && !item.isClaim
                      ? '#E89A52'
                      : '#CECECE'
                  "
                  size="mini"
                  @click="getCoupon(item)"
                >
                  {{
                    item.getstatus !== 'got' &&
                    !item.isClaim &&
                    item.remainNum !== 0
                      ? '立即领取'
                      : item.remainNum === 0
                      ? '已领完'
                      : '已领取'
                  }}
                </Button>
              </div>
            </div>
          </div>
          <div class="mx-3 mb-3">
            <Button
              style="padding-left: 12px; padding-right: 12px"
              round
              color="linear-gradient(135deg, #E82237 0%, #FF9D9D 100%)"
              size="large"
              @click="showCoupon = false"
              >完成</Button
            >
          </div>
        </ActionSheet>
        <!-- </div> -->
        <!-- //这里就是商品列表 -->
        <GoodsList id="GoodsList" ref="GoodsList" v-if="activeTab === 0" />
        <ActivityList v-else-if="activeTab === 1" id="ActivityList" />
        <CateList
          v-else-if="activeTab === 2"
          class="flex-grow mb-5"
          id="CateList"
        />
        <DiscoverList
          v-else-if="activeTab === 3"
          :brandId="brandDetail.brandId"
          id="DiscoverList"
        />

        <!-- 二维码弹框 -->
        <QRCodeDialog ref="QRCodeDialog" />
        <!-- 入群享好礼图片 -->
        <!-- //这里relateAssociationStatus数据要变 -->
        <img
          :src="require('@/assets/activityplace/shareGoodGift.png')"
          alt
          class="shareGoodGiftImg"
          @click="showQRcodeDialog"
          v-if="relateAssociationStatus"
        />
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import {
  NavBar,
  Icon,
  Button,
  Tab,
  Tabs,
  ActionSheet,
  Overlay,
  NumberKeyboard,
  Toast,
} from 'vant'
import GoodsList from './components/GoodsList'
import ActivityList from './components/ActivityList'
import CateList from './components/CateList'
import DiscoverList from './components/DiscoverList'
import { CodeToText } from 'element-china-area-data'
import { getBrandPlaceDetail, getCoupon } from './webApi'
import { accessLog } from '@/api/index'
import { priceMarkup, forwardDetail } from '@/api/forward.js'
import { getFollowInfo, follow, unfollow } from '@/api/follow.js'
import CustomView from '@/components/custom-view.vue'
import CustomPage from '@/components/custom-page.vue'
import Notice from './components/Notice'
import QRCodeDialog from '@/components/QRCodeDialog'
import { getQRCode } from '@/api/QRCode'
import { isWechatMP } from '@/utils/qiyukf'

// import {saveActIdListPage,getActIdListPage} from '@/utils/auth/'

export default {
  name: 'BrandPlaceIndex',
  components: {
    CustomPage,
    CustomView,
    GoodsList,
    ActivityList,
    CateList,
    DiscoverList,
    NavBar,
    Icon,
    Button,
    Tab,
    Tabs,
    ActionSheet,
    Overlay,
    NumberKeyboard,
    Notice,
    // Field,
    QRCodeDialog,
  },
  created() {
    //根据返回数据 ，控制二维码图片的显示隐藏
    //用一个常量存值 才有
    let actId = this.$route.query.actId
    if (actId) {
      localStorage.setItem('actIdListPage', actId)
    }
    if (!actId) {
      actId = localStorage.getItem('actIdListPage')
    }
    // console.log(this.actId, '打印的actId')
    getQRCode({
      actId,
    })
      .then((res) => {
        // console.log(res, 1111111)

        this.relateAssociationStatus = res.data
      })
      .catch((err) => {
        console.log(err)
      })

    //每一个tab品牌下每一个列表 或者卡片 用到的是oneTabBrandEveryPartId
    getBrandPlaceDetail(
      this.$route.params.partId ||
        this.$route.query.partId ||
        this.$route.params.oneTabBrandEveryPartId
    ).then(({ data }) => {
      if (data.state === 'FINISHED') {
        Toast({
          message: '活动已结束',
          position: 'center',
          duration: 1000,
        })
        this.$router.push('/')
      }
      this.brandDetail = data
      this.getFollowInfo()
      if (!this.$store.state.user.distributionFlag)
        accessLog({ type: 'brand', id: data.signBrandId })
    })
  },
  mounted() {
    const tabItem = 'GoodsList'

    this.getScrollTop(tabItem)
  },
  updated() {
    // 客服消息监听
    if (!isWechatMP()) {
      ysf('onunread', function(result) {
        this.qiyuTotal = result.total
      })
    }
  },
  data() {
    return {
      qiyuTotal: 0,
      scrollTop: 0,
      fold: false,
      ticking: false,
      isFollowing: false,
      followingId: null,
      CodeToText: CodeToText,
      brandDetail: {
        brandId: null,
        couponList: [],
      },
      expandDesc: false,
      activeTab: 0,
      showCoupon: false,
      forwardDetail: {},
      diagVisible: false,
      showOverlay2: false,
      showInput: false,
      customjiajia: '',
      jiajiaway: 1,
      urlAddress: null,
      showShare: false,

      browserType: localStorage.getItem('browserType'),
      relateAssociationStatus: null,
      actId: '',
    }
  },
  computed: {
    messageTotal() {
      return this.qiyuTotal + this.$store.state.app.messageNum
    },
  },
  methods: {
    like() {
      this.$store.dispatch('app/showLoading')
      if (this.isFollowing) {
        unfollow({
          id: this.followingId,
        })
          .then((res) => {
            this.getFollowInfo()
          })
          .catch(() => {
            this.$store.dispatch('app/hideLoading')
          })
      } else {
        follow({
          actBrandId: this.brandDetail.brandId,
          type: false,
        })
          .then((res) => {
            this.getFollowInfo()
          })
          .catch(() => {
            this.$store.dispatch('app/hideLoading')
          })
      }
    },
    getFollowInfo() {
      getFollowInfo(this.brandDetail.brandId)
        .then(({ data }) => {
          this.$store.dispatch('app/hideLoading')
          if (data) {
            this.isFollowing = true
            this.followingId = data.id
          } else {
            this.isFollowing = false
          }
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
    },
    showDiag() {
      forwardDetail({
        actId: this.$route.query.actId,
        partId: this.brandDetail.partId,
        partGoodsId: null,
        goodsId: null,
        suitId: null,
        customerId: null,
        retailId: null,
        forwardType: 'BRAND',
      }).then(({ data }) => {
        this.forwardDetail = data
        // this.diagVisible = true;
        this.generatePost()
      })
    },
    getCoupon(item) {
      getCoupon(item.couponId).then((res) => {
        Toast({
          message: res.message,
          position: 'center',
          duration: 1000,
        })
        this.$set(item, 'getstatus', 'got')
      })
    },
    showGetCoupon() {
      this.showCoupon = true
    },
    generatePost() {
      let urlAddress
      if (location.hostname === 'localhost') {
        urlAddress =
          window.location.origin +
          location.pathname +
          location.search +
          '&customerId=' +
          this.$store.state.user.forwardId
      } else {
        urlAddress =
          location.href + '&customerId=' + this.$store.state.user.forwardId
      }
      this.urlAddress = urlAddress
      let params = {
        actId: this.$route.query.actId,
        partId: this.brandDetail.partId,
        retailId: null,
        markupType: 'NONE',
        markupAmount: 0,
        markupRatio: 0,
        forwardType: 'BRAND',
        price: 0,
        urlAddress,
      }
      switch (this.jiajiaway) {
        case 1:
          params.markupType = 'NONE'
          params.price = this.forwardDetail?.price || this.brandDetail.price
          break
        case 2:
          params.markupType = 'AMOUNT'
          params.markupAmount = 10
          params.price = this.forwardDetail?.price + 10
          break
        case 3:
          params.markupType = 'RATIO'
          params.markupRatio = 0.2
          params.price = this.forwardDetail?.price * 1.2
          break
        case 4:
          if (!this.customjiajia) {
            return
          }
          params.markupType = 'AMOUNT'
          params.markupAmount = Number(this.customjiajia)
          params.price = this.forwardDetail?.price + Number(this.customjiajia)
          break
        default:
          break
      }
      console.log(params)
      priceMarkup(params).then(({ data }) => {
        // this.showShare = true;
        this.diagVisible = false
        this.$store.dispatch('sharePoster/show', {
          url: data.url,
          title: this.brandDetail.brandName,
          desc: this.brandDetail.brandIntroduce,
          link: urlAddress,
          imgUrl: this.brandDetail.brandLogo,
        })
      })
    },

    back() {
      if (this.$route.query.customerId) {
        this.$router.push({ path: '/' })
      } else {
        this.$router.back()
      }
    },

    getScrollTop(tabItem) {
      document.getElementById(tabItem).addEventListener(
        'scroll',
        () => {
          if (!this.ticking) {
            this.ticking = true
            this.scrollTop = document.getElementById(tabItem).scrollTop
            let visibleHeight = document.getElementById(tabItem).offsetHeight
            let listHeight = document.getElementById(tabItem).firstChild
              .offsetHeight
            console.log(
              `scrollTop: ${this.scrollTop}, listHeight: ${listHeight}, visibleHeight: ${visibleHeight}`
            )
            if (this.fold && this.scrollTop <= 20) {
              this.fold = false
            }
            if (
              !this.fold &&
              this.scrollTop > 20 &&
              listHeight - visibleHeight > 200
            ) {
              this.fold = true
            }
            this.$nextTick(() => {
              this.ticking = false
            })
          }
        },
        true
      )
    },

    clickTabs() {
      let tabItem = null
      this.scrollTop = 0
      if (this.activeTab === 0) tabItem = 'GoodsList'
      if (this.activeTab === 1) tabItem = 'ActivityList'
      if (this.activeTab === 2) tabItem = 'CateList'
      if (this.activeTab === 3) tabItem = 'DiscoverList'
      this.$nextTick(() => {
        this.getScrollTop(tabItem)
      })
    },

    showQRcodeDialog() {
      // 二维码弹框展示
      this.$refs.QRCodeDialog.open(this.relateAssociationStatus)
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  height: 100vh;
  #shadow {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 0;
    background: linear-gradient(rgba(0, 0, 0, 0.6), white);
  }
}
.van-overlay {
  z-index: 2;
}
.brand-place ::v-deep .van-nav-bar__right:active {
  opacity: 100;
}

/* //静止屏幕拉动 */
.modal-open {
  /* // 两个属性，禁止屏幕跟随滚动 */
  overflow: hidden;
  touch-action: none;
}

.shareGoodGiftImg {
  width: 120px;
  height: 90px;
  position: fixed;
  bottom: 20px;
  right: 10px;
}
</style>
